
import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
import BreedHeader from "@/components/base/table/header/BreedHeader.vue";
import Search from "@/components/semantics/AllPolicySearch.vue";
import Pagination from "@/components/base/pagination/PcmPagination.vue";
import Table from "@/components/base/table/body/TableAll.vue";
import { Action, Getter } from "vuex-class";
import { getParentArea, deepClone } from "@/common/utils";
import config from "@/config";
@Component({
  name: "AllPolicy",
  components: {
    BreedHeader,
    Table,
    Pagination,
    Search,
  },
})
export default class AllPolicy extends Vue {
  isKunMing: any = config.isKunMing;
  @Getter("id") private id!: any;
  @Getter("role") private role: any;
  @Getter("city") private city: any;
  @Action("policy/getAllPolicyList") private getAllPolicyList: any;
  loading: any = false;
  diffTime: any = 0;
  btns: any = [
    {
      label: "政策库",
      value: "policyData",
      total: 0,
      pages: 0,
      data: [],
      format: {
        title: "title",
        addressCodeName: "addressName",
        departmentName: "departmentName",
        releaseDate: "releaseDate",
        pageView: "pageView",
      },
      path: "/pcm/policyDetail",
    },
    {
      label: "政策办理",
      value: "declareData",
      total: 0,
      pages: 0,
      data: [],
      format: {
        title: "title",
        addressCodeName: "addressCodeName",
        departmentName: "departmentName",
        releaseDate: "gmtCreate",
        pageView: "pageView",
      },
      path: "/detail/apply",
    },
    {
      label: "政策大讲堂",
      value: "policyUnscrambleData",
      total: 0,
      pages: 0,
      data: [],
      format: {
        title: "title",
        addressCodeName: "addressName",
        departmentName: "departmentName",
        releaseDate: "releaseDate",
        pageView: "pageView",
      },
      path: "/detail/text",
    },
    {
      label: "无申请兑现",
      value: "enjoyWithoutData",
      total: 0,
      pages: 0,
      data: [],
      format: {
        title: "name",
        addressCodeName: "addressCodeName",
        departmentName: "departmentName",
        declarationStatus: "declarationStatus",
        releaseDate: "releaseTime",
        closingTime: "closingTime",
        pageView: "browseCount",
      },
    },
  ];
  tableData = [];
  format = {};
  isDialog = false;
  params: any = deepClone(this.$route.query.params);
  current: any = 1;
  size: any = 10;
  total: any = 0;
  pages: any = 0;
  currentBtn: any = 0;
  created() {
    this.getData();
  }
  searchData(params: any) {
    this.params = params;
    this.getData();
  }
  @Getter("cityId") private cityId: any;
  areaOption: any = this.$root.$data.areaOption;
  private async getData() {
    let beginDate = new Date();
    const provinceItem: any = getParentArea(this.areaOption, this.cityId);
    const provinceId = provinceItem ? provinceItem.value : provinceItem;
    const allArea: any = [];
    const tempAreaOption = deepClone(this.areaOption);
    const tempArea = tempAreaOption.filter((province: any) => {
      province.children = province.children
        .filter((city: any) => {
          const provinceItem: any = getParentArea(this.areaOption, city.value);
          const provinceId = provinceItem ? provinceItem.value : provinceItem;
          return city.value === this.cityId || provinceId === this.cityId;
        })
        .map((city: any) => {
          city.children.map((area: any) => {
            allArea.push(area.value);
            return area;
          });
          return city;
        });
      return province.value === provinceId;
    });
    allArea.push(provinceId);
    allArea.push(String(this.cityId));
    const options = {
      locationAddressCode: this.city.locationAddressCode,
      title: this.params,
      addressCode: "",
      pageNumber: this.current,
    };
    if (!this.city.locationAddressCode) {
      options.addressCode = this.city.id;
    }
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 30000);
    this.getAllPolicyList(options).then((res: any) => {
      this.loading = false;
      const { code, result, msg } = res;
      if (code === 200 && result) {
        const {
          declareData,
          enjoyWithoutData,
          policyData,
          policyUnscrambleData,
        } = result;
        // 通知类政策
        let {
          records: declareDataRecords,
          total: declareDataTotal,
          pages: declareDataPages,
        } = declareData;
        // 申报类政策
        let {
          records: enjoyWithoutDataRecords,
          total: enjoyWithoutDataTotal,
          pages: enjoyWithoutDataPages,
        } = enjoyWithoutData;
        // 解读类政策
        let {
          content: policyDataRecords,
          totalElements: policyDataTotal,
          totalPages: policyDataPages,
        } = policyData;
        // 信息类政策
        let {
          content: policyUnscrambleDataRecords,
          totalElements: policyUnscrambleDataTotal,
          totalPages: policyUnscrambleDataPages,
        } = policyUnscrambleData;
        const total: any = {
          declareDataTotal,
          enjoyWithoutDataTotal,
          policyDataTotal,
          policyUnscrambleDataTotal,
        };
        const pages: any = {
          declareDataPages,
          enjoyWithoutDataPages,
          policyDataPages,
          policyUnscrambleDataPages,
        };
        const totalAdd =
          (declareDataTotal || 0) +
          (enjoyWithoutDataTotal || 0) +
          (policyDataTotal || 0) +
          (policyUnscrambleDataTotal || 0);
        this.total = totalAdd;
        /*  informRecords = informRecords.map((item: any) => {
          const { department } = item;
          if (department) {
            const { departmentName } = department;
            item.departmentCN = departmentName;
          }
          item.type = "通知类";
          return item;
        }); */
        /*  declareRecords = declareRecords.map(
          ({
            labels,
            department,
            gmtCreate,
            gmtEnd,
            dispatchDirection,
            supportAmount,
            ...item
          }: any) => {
            const type = "申报类";
            const currentDate = new Date().getTime();
            const releasedDate: any = gmtCreate
              ? new Date(gmtCreate).getTime()
              : null;
            const deadDate: any = gmtEnd ? new Date(gmtEnd).getTime() : null;
            const depart = department.departmentName || null;
            const title = `${item.title}(${dispatchDirection})`;
            delete item.title;
            let state = "";
            if (gmtCreate && currentDate) {
              if (currentDate > releasedDate) {
                state = "兑现中";
              } else {
                state = "未开始";
              }
              if (deadDate && currentDate > deadDate) {
                state = "已截止";
              }
            }
            const label =
              labels.indexOf(",") > 0 ? labels.split(",") : labels.split("，");
            return {
              title,
              depart,
              tags: [state, ...label],
              ...item,
              type,
            };
          }
        );
        interpreRecords = interpreRecords.map((item: any) => {
          const { department } = item;
          if (department) {
            const { departmentName } = department;
            item.departmentCN = departmentName;
          }
          item.type = item.interpretationType;
          return item;
        });
        policyRecords = policyRecords.map((item: any) => {
          const { department } = item;
          if (department) {
            const { departmentName } = department;
            item.departmentCN = departmentName;
          }
          item.type = "信息类";
          return item;
        });
        */
        const records: any = {
          declareDataRecords: declareDataRecords.map((item: any) => {
            return {
              ...item,
              title: item.title + "-" + item.dispatchDirection,
            };
          }),
          enjoyWithoutDataRecords: enjoyWithoutDataRecords.map(
            (item: { dicTranslate: any }) => {
              return {
                ...item,
                addressCodeName: item.dicTranslate.addressCode,
                departmentName: item.dicTranslate.departmentId,
              };
            }
          ),
          policyDataRecords: policyDataRecords.map(
            (item: { content: any }) => item.content
          ),
          policyUnscrambleDataRecords: policyUnscrambleDataRecords.map(
            (item: { content: any }) => item.content
          ),
        };
        this.btns.forEach((btn: any) => {
          btn.pages = pages[btn.value + "Pages"] || 0;
          btn.total = total[btn.value + "Total"] || 0;
          btn.data = records[btn.value + "Records"] || [];
        });
        this.tableData = this.btns[this.currentBtn].data;
        this.total = this.btns[this.currentBtn].total;
        this.pages = this.btns[this.currentBtn].pages;
        console.log(this.pages);
        this.format = this.btns[this.currentBtn].format;
        let endDate = new Date();
        let diffDate = endDate.getTime() - beginDate.getTime();
        this.diffTime = diffDate / 1000;
      }
    });
  }
  // @Getter("cityName") private cityName: any;
  // @Watch("cityName")
  handleCityChange(newValue: any, oldValue: any) {
    this.current = 1;
    this.getData();
  }
  // @Watch(`$route`)
  handleRoutechange({ path }: any, from: any) {
    // location.reload()
    this.params = deepClone(this.$route.query.params);
    this.getData();
  }
  currentChange(params: any) {
    this.current = params;
    this.getData();
  }
  currentBtnChange(params: any) {
    this.current = 1;
    this.currentBtn = params;
    this.current = 1;
    this.getData();
    /* if ((this.current = 1)) {
      this.currentBtn = params;
      this.tableData = this.btns[params].data;
      this.total = this.btns[params].total;
      this.pages = this.btns[params].pages;
      this.format = this.btns[this.currentBtn].format;
    } else {
      this.currentBtn = params;
      this.current = 1;
      this.getData();
    } */
  }
  private handleChange(value: any) {}
  private handleEdit(item: any) {
    switch (item.type) {
      case "信息类":
        {
          this.$router.push({
            path: `/${this.isKunMing ? "kunming" : ""}detail/policy`,
            query: {
              policyId: item.id,
            },
          });
        }
        break;
      case "信息公示":
        {
          this.$router.push({
            path: `/${this.isKunMing ? "kunming" : ""}detail/publicy`,
            query: { publicyId: item.id },
          });
        }
        break;
      case "申报类":
        {
          const { declareItemDirections } = item;
          const { id } = declareItemDirections[0];
          this.$router.push({
            path: `/${this.isKunMing ? "kunming" : ""}detail/apply`,
            query: {
              directionId: id,
              projectId: item.id,
            },
          });
        }
        break;
      case "政策库类":
        {
          this.$router.push({
            path: `/${this.isKunMing ? "kunming" : ""}detail/inform`,
            query: { informId: item.id },
          });
        }
        break;
      case "文字解读":
        {
          this.$router.push({
            path: `${this.isKunMing ? "kunming" : ""}/detail/text`,
            query: { textId: item.id },
          });
        }
        break;
      case "漫画解读":
        {
          this.$router.push({
            path: `${this.isKunMing ? "kunming" : ""}/detail/img`,
            query: { imgId: item.id },
          });
        }
        break;
      default:
        {
          return this.$message.warning("未匹配到相应政策详情");
        }
        break;
    }
  }
}
